import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { ConfigService } from '../../services/config/config.service';
import { UsageReportsService } from '../../services/usage-reports/usage-reports.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
var UsageReportsComponent = /** @class */ (function () {
    function UsageReportsComponent(usageReportsService, returnUrlService, configService) {
        this.usageReportsService = usageReportsService;
        this.returnUrlService = returnUrlService;
        this.configService = configService;
        this.returnUrlService.save();
    }
    UsageReportsComponent.prototype.getUsageReportUrl = function (usageReport) {
        var params = "councilId=" + usageReport.councilId + "&year=" + usageReport.year + "&month=" + usageReport.month;
        return this.configService.config.apiRoot + "usagereport?" + params;
    };
    UsageReportsComponent.prototype.downloadReport = function (usageReport) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var reportFile;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.usageReportsService.getReportContent(usageReport)];
                    case 1:
                        reportFile = _a.sent();
                        saveAs(reportFile, usageReport.name + " " + usageReport.year + " " + usageReport.month + ".csv");
                        return [2 /*return*/];
                }
            });
        });
    };
    UsageReportsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.usageReportsService.all()];
                    case 1:
                        _a.usageReports = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UsageReportsComponent;
}());
export { UsageReportsComponent };
